const POW_DIFFICULTY = 2; // leading zero bytes required in SHA-256(eventId:nonce)

export interface PowSolution {
  nonce: number;
  difficulty: number;
}

export async function solvePoW(eventId: string, difficulty = POW_DIFFICULTY): Promise<PowSolution> {
  const enc = new TextEncoder();
  let nonce = 0;
  while (true) {
    const input = enc.encode(`${eventId}:${nonce}`);
    const hashBuf = await crypto.subtle.digest('SHA-256', input);
    const hash = new Uint8Array(hashBuf);
    let match = true;
    for (let i = 0; i < difficulty; i++) {
      if (hash[i] !== 0) { match = false; break; }
    }
    if (match) return { nonce, difficulty };
    nonce++;
  }
}
